export const processSessionKeyMapping = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      row.originalSessionKey = rowObj.originalSessionKey;
      row.overriddenSessionKey = rowObj.overriddenSessionKey;
    }
    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    let newId = rowObj.id + 1;
    let newRow = {
      id: newId,
      originalSessionKey: '',
      overriddenSessionKey: '',
    };
    bodyData.push(newRow);
  }
  return bodyData;
};

export const getFilteredArray = (array) => {
  let filterArr = [];

  for (let i = 0; i < array.length; i++) {
    if (
      array[i].originalSessionKey &&
      array[i].originalSessionKey != '' &&
      array[i].overriddenSessionKey &&
      array[i].overriddenSessionKey != ''
    ) {
      filterArr.push(array[i]);
    }
  }
  return filterArr;
};
